import axios from 'axios'

import type { components, operations } from '../constants/schema'

type GetNoticeListParams = Required<operations['NoticeController_findAll']['parameters']>['query']
type GetNotificationParams = Required<operations['UserNotificationController_findAll']['parameters']>['query']

/**
 * 공지 목록
 * @param size call 한 번에 불러오는 개수
 * @param offset pagination
 * @param categoryId 공지 카테고리 id
 * @returns ResListNotice
 */
export const getNoticeList = async ({ size = 50, offset = 0, categoryId }: GetNoticeListParams) => {
  return (await axios.get<components['schemas']['ResListNotice']>('/notice', { params: { size, offset, categoryId } }))
    .data
}

/**
 * 공지 상세
 * @param noticeId 공지사항 id
 * @returns NoticeDto
 */
export const getNoticeDetail = async (noticeId: number) => {
  return (await axios.get<components['schemas']['NoticeDto']>(`/notice/${noticeId}`)).data
}

/**
 * 로그인 유저 알림 목록
 * @param size call 한 번에 불러오는 개수
 * @param offset pagination
 * @param status 알림 상태
 * @returns ResListUserNotification
 */
export const getNotificationList = async ({ size = 50, offset = 0, status }: GetNotificationParams) => {
  return (
    await axios.get<components['schemas']['ResListUserNotification']>('/user/notification', {
      params: { size, offset, status },
    })
  ).data
}

/**
 * 읽지 않은 알림 개수 조회
 * @returns ResNumberResult
 */
export const getUnreadNotificationCount = async () => {
  return (await axios.get<components['schemas']['ResNumberResult']>('/user/notification/unread/count')).data
}

/**
 * 로그인 유저 알림 전체 읽기
 * @returns boolean
 */
export const readAllNotification = async () => {
  try {
    return (await axios.put<boolean>('/user/notification/readAll')).data
  } catch (error) {
    throw error
  }
}
